import React, { useState, useImperativeHandle, forwardRef, useContext } from 'react';
import poll_no_image from "../../../assets/images/icon/poll_no_image.png"; // Default image for the modal
import Cropper from "../../../../src/cropper/components/CroppersWizard.tsx"
import ImageUploader from './ImageUploader.jsx';
import { Language } from '../../../App.js';

const PostImageModal = forwardRef((props, ref) => {
    const { lang } = useContext(Language)
    const { type, getImagesUrl, showModal, setShowModal, getVideoSource } = props;
    const [coverImg, setCoverImg] = useState([]);  // For storing the selected image
    const [imgArr, setImgArr] = useState([]);  // For storing the selected image
    const [cropperOpen, setCropperOpen] = useState(false); // Whether the cropper modal is open
    const maxNumber = 6;
    // Additional cropper-related states (as per your Cropper component's props)
    const [ar, setAR] = useState(1);  // Aspect ratio
    const [maxARatio, setMaxAR] = React.useState(undefined);
    const [minARatio, setMinAR] = React.useState(undefined);
    const [resizable, setResizable] = useState(true); // Whether cropping is resizable
    const [hasSettings, setHasSettings] = useState(false); // Whether cropper settings are enabled
    const [updateCoordinatesCheck, setUpdateCoordinatesCheck] = useState(false); // For coordinate updates
    const [fileUploadRefs, setFileUploadRefs] = React.useState({});
    const [numberOfImages, setNumberOfImages] = React.useState(maxNumber);

    const [height, setHeight] = React.useState(undefined);
    const [width, setWidth] = React.useState(undefined);
    const [top, setTop] = React.useState(undefined);
    const [left, setLeft] = React.useState(undefined);
    const [selectedVideo, setSelectedVideo] = useState(null);

    // Handle closing the cropper modal
    const handleClose = () => {
        setCropperOpen(false); // Close the cropper modal
    };
    useImperativeHandle(ref, () => ({
        onImageRemove,  // Exposing the onImageRemove function to be callable from the parent
    }));
    const onImageRemove = (index) => {
        setCoverImg((prev) => prev.filter((_, i) => i !== index));
        setImgArr((prev) => prev.filter((_, i) => i !== index));
        setNumberOfImages((prev) => Math.max(0, prev - 1));
    };


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedVideo(file);
            getVideoSource(file);
            setShowModal(false)
        }
    };
    return (
        showModal && (
            <div className="modal fade show d-block"  aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-lg"> {/* Large modal */}
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{lang.add_media}</h5>
                        </div>
                        <div className="modal-body text-center py-5">
                            <>
                                <Cropper
                                    images={coverImg}
                                    setImages={setCoverImg}
                                    imagesArr={imgArr}
                                    setImagesArr={setImgArr}
                                    max={maxNumber}
                                    allowCrop={true}
                                    ar={ar}
                                    setAR={setAR}
                                    minARatio={minARatio}
                                    setMaxAR={setMaxAR}
                                    maxARatio={maxARatio}
                                    setMinAR={setMinAR}
                                    resizable={resizable}
                                    setResizable={setResizable}
                                    handleClose={handleClose}
                                    fileUploadRefs={fileUploadRefs}
                                    setFileUploadRefs={setFileUploadRefs}
                                    numberOfImages={numberOfImages}
                                    setNumberOfImages={setNumberOfImages}
                                    hasSettings={hasSettings}
                                    setHasSettings={setHasSettings}
                                    updateCoordinatesCheck={updateCoordinatesCheck}
                                    setUpdateCoordinatesCheck={setUpdateCoordinatesCheck}
                                    height={height}
                                    setHeight={setHeight}
                                    width={width}
                                    setWidth={setWidth}
                                    top={top}
                                    setTop={setTop}
                                    left={left}
                                    setLeft={setLeft}
                                    cropperOpen={cropperOpen}
                                    setCropperOpen={setCropperOpen}
                                />
                            </>
                            <>
                                {coverImg.length > 0 && !cropperOpen ?

                                    <ImageUploader
                                        coverImg={imgArr}
                                        maxNumber={maxNumber}
                                        setCropperOpen={setCropperOpen}
                                        fileUploadRefs={fileUploadRefs}
                                        numberOfImages={numberOfImages}
                                        setNumberOfImages={setNumberOfImages}
                                        onImageRemove={onImageRemove}
                                        setCoverImg={setImgArr}
                                        getImagesUrl={getImagesUrl}
                                    />
                                    :
                                    <>
                                        <div className="upload-icon mb-3">
                                            <img className="w-300" src={poll_no_image} alt="Upload"/>
                                        </div>
                                        <p>{lang.share_images_or_videos_in_your_post}</p>
                                        <div className="d-flex gap-3 flex-column align-items-center justify-content-center">
                                            {type !== "video" ? <button
                                                className="btn btn-primary post-image-modal px-4"
                                             
                                                onClick={() =>
                                                    fileUploadRefs[numberOfImages - 1]?.current.click()
                                                }
                                            >
                                                {lang.browse_images}
                                            </button>
                                                :
                                                <button
                                                    className="btn btn-primary post-image-modal px-4"
                                                    onClick={() => {
                                                        const input = document.createElement('input');
                                                        input.type = 'file';
                                                        input.accept = 'video/*';
                                                        input.addEventListener('change', handleFileChange);
                                                        input.click();
                                                    }}
                                                >
                                                    {lang.browse_videos}
                                                </button>
                                            }
                                        </div>
                                    </>
                                }
                            </>

                        </div>
                        <div className="modal-footer border-0 pt-0">
                            <button
                                className="btn custom-gray-border text-decoration-none"
                                onClick={() => {
                                    setShowModal(false)
                                }}
                            >
                                {lang.cancel}
                            </button>
                            <button
                                className="btn post-image-modal-action"
                               
                                onClick={() => {
                                    if (type !== "video") {
                                        getImagesUrl(coverImg);
                                    } else {
                                        getVideoSource(selectedVideo);
                                    }
                                    setShowModal(false); // Close modal after cropping (or save the cropped image)
                                }}
                            >
                                {lang.done}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
})

export default PostImageModal;

